import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconStatusIndicatorLarge(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 4c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
